﻿// src/plugins/vuetify.js

import '@fortawesome/fontawesome-free/css/all.css' // Ensure you are using css-loader
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import * as Components from 'vuetify/lib/components/'
import * as Directives from 'vuetify/lib/directives'


import colors from 'vuetify/lib/util/colors'
import vuetifyEn from 'vuetify/lib/locale/en'
import detectLocale from '../i18n/detectLocale'

// Vuetify doesn't ship an Icelandic locale, so we build one from the English shape and translate the
// handful of strings that actually appear in the chrome (data-table footer, no-data text, sort).
const vuetifyIs = {
    ...vuetifyEn,
    noDataText: 'Engin gögn',
    dataIterator: {
        ...vuetifyEn.dataIterator,
        loadingText: 'Hleð gögnum...'
    },
    dataTable: {
        ...vuetifyEn.dataTable,
        itemsPerPageText: 'Raðir á síðu:',
        sortBy: 'Raða eftir',
        ariaLabel: { ...vuetifyEn.dataTable.ariaLabel }
    },
    dataFooter: {
        ...vuetifyEn.dataFooter,
        itemsPerPageText: 'Atriði á síðu:',
        itemsPerPageAll: 'Allt',
        nextPage: 'Næsta síða',
        prevPage: 'Fyrri síða',
        firstPage: 'Fyrsta síða',
        lastPage: 'Síðasta síða',
        pageText: '{0}–{1} af {2}'
    },
    noResultsText: 'Engar samsvarandi færslur fundust'
}

Vue.use(Vuetify, {
    components: {
        ...Components
    },
    directives: {
        ...Directives
    },
})

// Webcy brand palette. Kept in one place and applied to both the light and dark themes so the
// brand purple survives when dark mode is on (otherwise Vuetify would fall back to its default blue).
const brand = {
    primary: '#a30d6e',
    accent: '#621573'
}

const opts = {
    icons: {
        iconfont: 'fa'
    },
    lang: {
        locales: { en: vuetifyEn, is: vuetifyIs },
        // Start from the cached preference / browser language (baseLayout reconciles with the server value).
        current: detectLocale()
    },
    theme: {
        // Start from the persisted preference so a returning user doesn't get a flash of the wrong
        // theme before /api/users/current resolves (baseLayout reconciles it with the server value).
        // Dark mode only applies to the admin dashboard — the same bundle also renders /signin,
        // /forgotten-password, /adopt-player, etc., and those must always stay light.
        dark: window.location.pathname.toLowerCase().startsWith('/dashboard')
            && window.localStorage.getItem('webcy-dark-mode') === 'true',
        // Expose theme colors as CSS variables (var(--v-primary-base) etc.) — the correct Vuetify way
        // to reference brand colors from custom CSS instead of hard-coding the hex.
        options: {
            customProperties: true
        },
        themes: {
            light: {
                ...brand,
                secondary: '#161514'
            },
            dark: {
                ...brand,
                secondary: '#757575'
            }
        }
    }
}

export default new Vuetify(opts)